import { render, staticRenderFns } from "./Usuario.vue?vue&type=template&id=13c4d51c&scoped=true&"
import script from "./Usuario.vue?vue&type=script&lang=js&"
export * from "./Usuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4d51c",
  null
  
)

export default component.exports